<!--suppress JSUnresolvedReference -->
<script>
import storage from "@/utils/storage";
import ProductHover from "@/components/group/ProductHover.vue";

export default {
  name: "GroupHeader",
  components: {ProductHover},
  data() {
    return {
      lang: 'tc',
      langList: [
        {value: 'tc', name: '繁'},
        {value: 'sc', name: '简'},
        {value: 'en', name: 'ENG'}
      ],
      showNav: false,
      show_investor_mobile: false,
      showHover: false,
      show_product_mobile: false,
      food: [
        'home', 'about', 'wedding-information', 'contact'
      ],
      coffee: [
        'home',
        'product',
        'coffee',
        'shop',
        'gourmet',
        'boutique',
        'history',
      ],
      disabledLanguage: false
    }
  },
  watch: {
    $route() {
      this.showNav = false;
      this.show_investor_mobile = false;
      this.show_product_mobile = false;
    }
  },
  mounted() {
    this.selectLangHandle(storage.getLanguage());
    this.$bus.$on('changeLanguage', (bol) => {
      this.disabledLanguage = bol;
    })
  },
  methods: {
    selectLangHandle(type) {
      if (this.disabledLanguage) return;
      this.lang = type;
      this.$i18n.locale = type;
      storage.setLanguage(type);
    },
    toProduct() {
      if (this.$route.path !== '/home') {
        this.$router.replace('/home?redirect=group_product');
        return;
      }
      document.getElementById('group_product').scrollIntoView({
        behavior: "smooth",// 过渡动画效果 详细看文档
        block: "start" // 滚动到的位置 可选start center end1
      });
    },
    updateHover(e) {
      this.showHover = e
    }
  }
}
</script>

<template>
  <div class="w-full fixed top-0 left-0 z-50">
    <div class="container mx-auto h-20 flex items-center justify-between xs:px-10 px-3">
      <div class="flex items-center">
        <div class="flex cursor-pointer">
          <a href="https://www.kafelaku.com" class="ml-7">
            <img src="@/assets/coffee-logo.png" alt="logo" class="h-16 hidden sm:block"/>
          </a>
          <a href="https://www.kafelaku.com" class="ml-3 mt-3 hidden sm:flex text-logo text-2xl font-serif items-center">
            {{ $t('footer.company') }}
          </a>
        </div>
        <!--        <img src="@/assets/coffee-logo.png" alt="logo" class="h-16 hidden sm:block"/>-->
        <!--        <ul class="ml-10 text-lg text-white hidden sm:flex">-->
        <!--          <li class="px-4 cursor-pointer hover:underline h-20 flex items-center">-->
        <!--            <router-link to="/">{{ $t("group.header.nav.home") }}</router-link>-->
        <!--          </li>-->
        <!--          <li class="px-4 cursor-pointer hover:underline h-20 flex items-center">-->
        <!--            <router-link to="/about">{{ $t("group.header.nav.about") }}</router-link>-->
        <!--          </li>-->
        <!--          <el-dropdown placement="bottom">-->
        <!--            <li class="px-4 cursor-pointer hover:underline h-20 flex items-center text-white text-lg">-->
        <!--              <a>{{ $t("group.header.nav.investor") }}</a>-->
        <!--            </li>-->
        <!--            <el-dropdown-menu slot="dropdown">-->
        <!--              <el-dropdown-item>-->
        <!--                <a target="_blank"-->
        <!--                   href="https://mediumir.com/zh-hant/01869">{{ $t("group.header.investor.before") }}</a>-->
        <!--              </el-dropdown-item>-->
        <!--              <el-dropdown-item>-->
        <!--                <div @click="$router.push('/investor-relations')">-->
        <!--                  {{ $t("group.header.investor.after") }}-->
        <!--                </div>-->
        <!--              </el-dropdown-item>-->
        <!--            </el-dropdown-menu>-->
        <!--          </el-dropdown>-->
        <!--          <li class="px-4 cursor-pointer hover:underline h-20 flex items-center " @mousemove="showHover = true"-->
        <!--              @mouseleave="showHover = false">-->
        <!--            <a class="cursor-pointer" @click="toProduct">{{ $t("group.header.nav.product") }}</a>-->
        <!--          </li>-->
        <!--          <li class="px-4 cursor-pointer hover:underline h-20 flex items-center">-->
        <!--            <router-link to="/join">{{ $t("group.header.nav.join") }}</router-link>-->
        <!--          </li>-->
        <!--        </ul>-->
        <!--        <div class="sm:hidden">-->
        <!--          <i class="el-icon-more  block text-white text-3xl" @click="showNav = !showNav"></i>-->
        <!--        </div>-->
      </div>
      <div class="flex text-coffee">
        <div class="px-2.5 mx-1 cursor-pointer" v-for="(item,index) in langList" :key="item.value"
             :class="{'language-selector': lang === item.value}"
             @click="selectLangHandle(item.value)">
          {{ item.name }}
        </div>
      </div>
    </div>
    <product-hover :visible="showHover" @updateVisible="updateHover"/>
    <el-drawer
        title=""
        modal-append-to-body
        append-to-body
        size="60%"
        :visible.sync="showNav"
        direction="ltr">
      <ul class="text-lg flex flex-col">
        <li class="px-4 leading-5 h-5 text-xl py-5 hover:bg-coffeePink transition-all flex items-center">
          <router-link to="/">{{ $t("group.header.nav.home") }}</router-link>
        </li>
        <li class="px-4 leading-5 h-5 text-xl py-5 hover:bg-coffeePink transition-all flex items-center"
            @click="show_investor_mobile = !show_investor_mobile">
          <a>{{ $t("group.header.nav.investor") }} </a>
          <i class="ml-1" :class="[show_investor_mobile?'el-icon-arrow-down':'el-icon-arrow-right']"></i>
        </li>
        <li class="pl-10 overflow-hidden transition-all" :style="{maxHeight: show_investor_mobile?'100px':'0px'}">
          <a target="_blank" class="my-3 block"
             href="https://mediumir.com/zh-hant/01869">{{ $t("group.header.investor.before") }}</a>
          <p class="py-3" @click="$router.push('/investor-relations')">
            {{ $t("group.header.investor.after") }}
          </p>
        </li>
        <li class="px-4 leading-5 h-5 text-xl py-5 hover:bg-coffeePink transition-all flex items-center"
            @click="show_product_mobile = !show_product_mobile">
          <a>{{ $t("group.header.nav.product") }}</a>
          <i class="ml-1" :class="[show_product_mobile?'el-icon-arrow-down':'el-icon-arrow-right']"></i>
        </li>
        <li class="pl-10 overflow-hidden transition-all" :style="{maxHeight: show_product_mobile?'500px':'0px'}">
          <div class="text-lg font-bold mt-1">
            <a :href="'http://localhost:8888/#/home?locale='+$i18n.locale"
               target="_blank">{{ $t('group.header.hover.food.title') }}</a>
          </div>
          <ul>
            <li v-for="(item, index) in food" :key="index" class="py-3 cursor-pointer hover:underline text-sm">
              <a target="_blank" :href="`http://localhost:8888/#/${item}?locale=`+$i18n.locale">{{
                  $t('group.header.hover.food.' + item)
                }}</a>
            </li>
          </ul>
          <div class="text-lg font-bold mt-1">
            <a :href="'http://localhost:8888/#/home?locale='+$i18n.locale"
               target="_blank">{{ $t('group.header.hover.coffee.title') }}</a>
          </div>
          <ul>
            <li v-for="(item, index) in coffee" :key="index" class="py-3 cursor-pointer hover:underline text-sm">
              <a target="_blank" :href="`http://localhost:8888/#/${item}?locale=`+$i18n.locale">{{
                  $t('group.header.hover.coffee.' + item)
                }}</a>
            </li>
          </ul>
        </li>
      </ul>
    </el-drawer>
  </div>
</template>

<style scoped>
.language-selector {
  background-color: orange;
  color: black;
  border-radius: 5px;
}
</style>